import Icon from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';


const ImageIcon = ({ src, style }) => {
    const styles = { width: '20px', height: '20px', ...style }
    return (
        <object style={styles} data={`/icons/${src}`}>
        </object>
    )
}
ImageIcon.propTypes = {
    src: PropTypes.string.isRequired,
    style: PropTypes.object
}

const CustomIcon = ({ style = {}, ...props }) => (
    <Icon component={ImageIcon} style={style} {...props} />
)
CustomIcon.propTypes = {
    style: PropTypes.object
}
export { CustomIcon, ImageIcon };
